import React, { useEffect, useState } from "react";

import { Box, StepLabel } from "@mui/material";
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";

import { customHistory } from "App";
import { ButtonVariant } from "Constant/button";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StepWizard from "react-step-wizard";

import StandartButton from "components/atoms/StandartButton";

import ConfettiEffect from "../ConfettiEffect";
import "./LeadsCss.css";
import LeadsStep1 from "./LeadsStep1";
import LeadsStep3 from "./LeadsStep3";
import LeadsStep6 from "./LeadsStep6";
import LeadsStep22 from "./LeadsStep22";
import LeadsStep12 from "./LeadStep12";
import * as Styled from "./LeadWizard/LeadWizard.styled";

const LeadsWizardComponent = () => {
    const language = useSelector((state) => state.languagesState.languages);
    const steps = [
        `${language?.lead?.connect ?? "Connect"}`,
        `${language?.lead?.mapping ?? "Mapping"}`,
        `${language?.lead?.customize_and_finish ?? "Customize and Finish"}`,
    ];
    const [stepWizard, setStepWizard] = useState(null);
    const [user, setUser] = useState({});
    const [activeStep, setActiveStep] = useState(0);
    const [connectionName, setConnectionName] = useState("");
    const [filterFieldList, setFilterFieldList] = useState([]);

    const [step1Data, setStep1Data] = useState([]);

    const navigate = useNavigate();

    const assignStepWizard = (instance) => {
        setStepWizard(instance);
    };

    const [selectedSourceId, setSelectedSourceId] = useState(0);
    const [templates, setTemplates] = useState([]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        window.localStorage.removeItem("swo");
    }, []);

    useEffect(() => {
        activeStep === 2 && scrollToTop();
    }, [activeStep]);

    const assignUser = (val) => {
        setUser((user) => ({
            ...user,
            ...val,
        }));
    };

    const handleStepChange = (e) => {
        setActiveStep(e.activeStep - 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        if (activeStep === 4)
            customHistory.push({
                pathname: customHistory.location.pathname,
                search: customHistory.location.search,
                hash: "step5",
            });
    }, [activeStep]);
    return (
        <div
            className={
                activeStep === 4
                    ? "wizard-area-main leads-wizard-area wizard-area-completed"
                    : "wizard-area-main leads-wizard-area"
            }
        >
            {activeStep === 4 ? (
                <ConfettiEffect></ConfettiEffect>
            ) : (
                <div>
                    <div className="wizard-header-area">
                        <Styled.ExitButton>
                            <StandartButton
                                data-cy="lead-wizard-exit"
                                variant={ButtonVariant.BLACK_OUTLINED}
                                style={{ width: "100%" }}
                                onClick={() => navigate("/lead-connections")}
                            >
                                <Box color="#F66700">EXIT WIZARD</Box>
                            </StandartButton>
                        </Styled.ExitButton>
                    </div>
                    <div>
                        <Box sx={{ width: "100%" }}>
                            <Stepper
                                data-cy="lead-wizard-stepper"
                                className="stepper-template mb-4"
                                activeStep={activeStep}
                                sx={{ justifyContent: "center" }}
                            >
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                    </div>
                </div>
            )}
            <div className="wizard-step-wizard">
                <StepWizard
                    transitions="false"
                    isHashEnabled={false}
                    instance={assignStepWizard}
                    onStepChange={handleStepChange}
                >
                    <LeadsStep1
                        setStep1Data={setStep1Data}
                        setSelectedSourceId={setSelectedSourceId}
                        setTemplates={setTemplates}
                        userCallback={assignUser}
                    />
                    <LeadsStep12
                        step1Data={step1Data}
                        setSelectedSourceId={setSelectedSourceId}
                        setTemplates={setTemplates}
                        userCallback={assignUser}
                        setFilterFieldList={setFilterFieldList}
                    />
                    <LeadsStep22
                        selectedSourceId={selectedSourceId}
                        templates={templates}
                        setTemplates={setTemplates}
                        user={user}
                        userCallback={assignUser}
                    />
                    <LeadsStep3
                        user={user}
                        userCallback={assignUser}
                        setConnectionName={setConnectionName}
                        filterFieldList={filterFieldList}
                    />
                    <LeadsStep6
                        user={user}
                        userCallback={assignUser}
                        connectionName={connectionName}
                    />
                </StepWizard>
            </div>
        </div>
    );
};
export default LeadsWizardComponent;
